<template>
  <div>
    <sushi-nav v-if="isSushiHub" />
    <intro-header :isSushi="isSushiHub" />
    <div>
      <div :class="{ 'container':  !isSushiHub }">
        <div>
          <component :is="currentComponent" />
        </div>
      </div>
    </div>


    <TermsAndCondition v-if="isSushiHub" />
  </div>
</template>

<script>
import IntroHeader from "./introheader.vue";
import Resturants from "./Resturant/Resturants";
import shared from "../../sharedscripts/master/Intro.js";
import SushiNav from "@/components/sushiHub/sushiNav";
import TermsAndCondition from "@/components/sushiHub/termsAndCondition";
import {mapGetters} from "vuex";
export default {
  name: "Intro",
  components: {
    TermsAndCondition,
    SushiNav,
    IntroHeader,
    Resturants
  },

  computed: {
    ...shared.computed,
    ...mapGetters(["hqDoc"]),
    isSushiHub() {
      return this.hqDoc && this.hqDoc.IsSushiHub;
    }
  },

  data() {
    return {
      ...shared.data()
    };
  },
  filters: {
    ...shared.filters,
  },
  methods: {
    ...shared.methods,
  },
};
</script>
